<template>
  <section id="y9mpGq6gyPvCumKeuzsP5RJyplziJtQmRS5529r4ApY=" class="faq_area pt-100 pb-100">
    <div class="container">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s">
              <span style="border-top: 5px solid black"> FAQ </span>
            </h4>
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              <p style="color: black">Frequently Asked Question</p>
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->

      <!-- START CONTENT -->
      <div class="row">
        <div class="col-lg-12 wow fadeInUp"
          data-wow-duration="1.0s"
          data-wow-delay="0.4s">

          <div class="accordion" id="accordionExample">
            <div class="mt-3" style="background-color: #F9F9F9; padding:10px"
                  v-for="(faq, index) in faqs"
                  :key="index">
              <div class="" v-bind:id="'heading'+index" data-toggle="collapse" v-bind:data-target="'#collapse'+index" aria-expanded="true" v-bind:aria-controls="'collapse'+index">
                  <button class="btn" type="button" >
                    {{ faq.pertanyaan }}
                  </button>
              </div>

              <div v-bind:id="'collapse'+index" class="collapse hide" v-bind:aria-labelledby="'heading'+index" data-parent="#accordionExample">
                <div class="card-body">
                    <div
                      v-html="faq.jawaban"
                    ></div>
                </div>
              </div>
            </div>
          </div>

          <br/>
          <br/>
          <div class="centerBlock">
            <paginate
              v-model="page"
              :page-count=pageCount
              :click-handler="clickCallback"
              :prev-text="'Sebelumnya'"
              :next-text="'Selanjutnya'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :active-class="'myActiveBtn'"
            >
            </paginate>
          </div>
        </div>
      </div>
      <!-- END CONTENT -->
    </div>
  </section>
</template>
<script>
import FaqDataService from "../services/FaqDataService";
import Paginate from "vuejs-paginate-next";

export default {
  name: "faqView",
  data() {
    return {
      pageCount: 0, //initial page pagination
      dataPerPage: 6, //for limiting per page
      faqs: [],
      page: 1
    };
  },
  components: {
    paginate: Paginate,
  },
  methods: {
    getCountAllFaqs() {
      FaqDataService.getAll(0, 999999999999999)
        .then((response) => {
          var length = response.data.data.length;
          var divided = length / this.dataPerPage;
          this.pageCount = Math.ceil(divided);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clickCallback (pageNum) {
      console.log(pageNum-1);
      this.retrieveFaqs(pageNum-1, this.dataPerPage);
    },
    retrieveFaqs(offset, limit) {
      FaqDataService.getAll(offset, limit)
        .then((response) => {
          this.faqs = response.data.data;
          console.log(this.faqs);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.getCountAllFaqs();
    this.retrieveFaqs(0, this.dataPerPage);
  },
};
</script>

<style></style>
